import { useQuery } from "@apollo/client";
import { useDatesContext } from "context/DatesContext";
import gql from "graphql-tag";

export const useCustomerSummary = (storeId, start, end) => {
  const { customerSummary, loading } = useAllCustomerSummary(
    storeId,
    start,
    end
  );
  return {
    loading,
    customerSummary,
  };
};

function useAllCustomerSummary(storeId, start, end) {
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllCustomerSummary", 60 * 1000);
  const { data, loading, error } = useQuery(
    gql`
      query GetCustomerSummary($customerSummaryInput: CustomerSummaryInput!) {
        customerSummary(input: $customerSummaryInput) {
          _id {
            start
            end
          }
          count
        }
      }
    `,
    {
      variables: {
        customerSummaryInput: {
          storeId,
          start,
          end,
        },
      },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const customerSummary = data?.customerSummary ?? [];
  return { customerSummary, loading };
}
